export default "__VITE_ASSET__BZEAdw7f__"